import React from 'react';
import {
    Image,
    Stack,
    Card,
    CardBody,
    Heading,
    Text,
    CardFooter,
    GridItem, useBreakpointValue
} from '@chakra-ui/react'; // Import relevant components
import {Link} from 'react-router-dom'; // For routing
import PropTypes from 'prop-types';


const IntroCard = ({cardData}) => {
    const isMobile = useBreakpointValue({base: true, md: false});

    IntroCard.propTypes = {
        cardData: PropTypes.shape({
            id: PropTypes.number.isRequired,
            smallTitle: PropTypes.string,
            mainTitle: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            image: PropTypes.string.isRequired,
            linkLabel: PropTypes.string
        }),
    };

    return (
        <Card
            direction={{base: 'column', sm: 'row'}}
            overflow="hidden"
            variant="outline"
            width={'fit-content'}
            borderWidth="0"
            className='grid-div-10-col column-1-10'
            style={{display: 'grid', paddingTop: "2rem", paddingBottom: "2rem"}}
        >
            {cardData.imageOrientation === 'left' || isMobile ? (
                <>
                    <GridItem className="column-1-5">
                        <Image
                            objectFit="cover"
                            maxW={{base: '100%'}}
                            src={cardData.image}
                            alt="image"
                            width="100%"
                        />
                    </GridItem>

                    <GridItem className="column-7-10" style={{margin: "auto"}}>
                        <Stack maxW='471px'>
                            <CardBody className='card-component' pr={0} pl={0}>
                                <Text className="header-2" py="0">{cardData.smallTitle}</Text>
                                <Heading variant="heading3">{cardData.mainTitle}</Heading>
                                <Text py="2" whiteSpace="pre-line" textStyle="customBodyMedium">
                                    {cardData.description}
                                </Text>
                            </CardBody>
                            {cardData.linkLabel && (
                                <CardFooter>
                                    <Link className="linkTo" to={`seemore/${cardData.id}`}>
                                        {cardData.linkLabel}
                                    </Link>
                                </CardFooter>
                            )}
                        </Stack>
                    </GridItem>
                </>
            ) : (
                <>
                    <GridItem className="column-1-4">
                        <Stack maxW='471px'>
                            <CardBody className='card-component' pr={0} pl={0}>
                                <Text className="header-2" py="0">{cardData.smallTitle}</Text>
                                <Heading variant="heading3">{cardData.mainTitle}</Heading>
                                <Text py="2" whiteSpace="pre-line" textStyle="customBodyMedium">
                                    {cardData.description}
                                </Text>
                            </CardBody>
                            {cardData.linkLabel && (
                                <CardFooter>
                                    <Link className="linkTo" to={`seemore/${cardData.id}`}>
                                        {cardData.linkLabel}
                                    </Link>
                                </CardFooter>
                            )}
                        </Stack>
                    </GridItem>

                    <GridItem className="column-6-10">
                        <Image
                            objectFit="cover"
                            maxW={{base: '100%'}}
                            src={cardData.image}
                            alt="image"
                            width="100%"
                        />
                    </GridItem>
                </>
            )}
        </Card>
    );
};

export default IntroCard;